<template>
  <o-form-wrapper
    v-model="item"
    :form-state="formState"
    :schema="schema"
    :server-errors="_se"
    :v="$v.item"
  >
    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="name"
    >
      <o-text-field
        v-model="item.name"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="name"
        v-bind="schema.fields.name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="phone_number"
    >
      <o-text-field
        v-model="item.phone_number"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="phone_number"
        v-bind="schema.fields.phone_number"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="sizes"
    >
      <truck-size-form-table
        v-model="item.sizes"
        :form-state="formState"
        :label="schema.fields.sizes.label"
        :level="level + 1"
        :server-errors="_se.sizes"
        :validators="$v.item.sizes"
      >
      </truck-size-form-table>
      <!-- UNCOMMENT TO USE Cards
      <truck-size-form-cards v-model="item.sizes"
          :validators="$v.item.sizes"
          :form-state="formState"
          :label="schema.fields.sizes.label"
          :level="level+1"
          :server-errors="_se.sizes">
      </truck-size-form-cards>
      -->
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="rego"
    >
      <o-text-field
        v-model="item.rego"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="rego"
        v-bind="schema.fields.rego"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="fleet_no"
    >
      <o-text-field
        v-model="item.fleet_no"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="fleet_no"
        v-bind="schema.fields.fleet_no"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="description"
    >
      <o-text-field
        v-model="item.description"
        :form-state="formState"
        :server-errors="_se"
        :validators="$v.item"
        name="description"
        v-bind="schema.fields.description"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="user"
    >
      <o-select
        v-model="item.user"
        :form-state="formState"
        :items="optionUserItems"
        :loading="optionUserWorking"
        :server-errors="_se"
        :validator="$v.item[schema.fields.user.name]"
        :validators="$v.item"
        clearable
        flat
        name="user"
        text-field="username"
        v-bind="schema.fields.user"
        value-field="id"
      ></o-select>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import {cleanUpModel} from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import UseCodeModulesMixin from "@/vue-ocom/mixins/UseCodeModulesMixin.js";
import {validationMixin} from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import {default as TruckSizeFormTable} from "../../truck_size/components/ItemFormTable";
// import { default as TruckSizeFormCards } from '../../truck_size/components/ItemFormCards';

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("CodeTruck"),
    CreateCodeTableFetchMixin(["User"]),
    UseCodeModulesMixin(["User"]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    TruckSizeFormTable,
    //TruckSizeFormCards,
  },
  props: {
    item: {
      type: Object,
      default: () => {
      },
    },
    level: {type: Number, default: 0},
    inModal: {type: Boolean, default: false},
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.CodeTruck, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {
  },
};
</script>
